import { RESET_USER_DATA, SET_USER_DATA } from "../actionTypes/userProfile";

const initialState = {
  UserEmail: "",
  UserName: "",
  Phone: null,
  UserId: null,
  CompanyName: null,
  isAdmin: false,
  isAuthenticated: false,
  isAuthorized: false,
  hasSystemsAccess: false
};

const userData = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return { ...state, ...action.payload.user };
    case RESET_USER_DATA:
      return initialState;
    default:
      return state;
  }
};

export default userData;
